import React, { useState, useEffect } from "react";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";

const OTApprovalModal = ({ show, initialData, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    id: 0,
    stepOrder: 1,
    approverId: "",
    position: 0,
    note: "",
    configGroup: "Office",
    isCCOnly: false,
  });

  const [users, setUsers] = useState([]);

  // Load user list every time Modal is opened
  useEffect(() => {
    if (show) {
      const fetchUsers = async () => {
        try {
          const res = await axiosClient.get(API_ENDPOINTS.users);
          console.log("Fetched Users List:", res.data);
          setUsers(res.data || []);
        } catch (e) {
          console.error("Failed to fetch users:", e);
        }
      };
      fetchUsers();
    }
  }, [show]);

  // Sync initial data when Editing or Resetting for New Entry
  useEffect(() => {
    if (show) {
      if (initialData) {
        setFormData({
          id: initialData.id || 0,
          stepOrder: initialData.stepOrder || 1,
          approverId: initialData.approverId || "",
          position: initialData.position || 0,
          note: initialData.note || "",
          configGroup: initialData.configGroup || "Office",
          isCCOnly: initialData.isCCOnly || false,
        });
      } else {
        setFormData({
          id: 0,
          stepOrder: 1,
          approverId: "",
          position: 0,
          note: "",
          configGroup: "Office",
          isCCOnly: false,
        });
      }
    }
  }, [initialData, show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Normalize data before submitting to Backend
    const payload = {
      ...formData,
      id: parseInt(formData.id) || 0,
      approverId: formData.approverId ? parseInt(formData.approverId) : null,
      stepOrder: formData.stepOrder ? parseInt(formData.stepOrder) : 0,
      position: parseInt(formData.position) || 0,
    };

    console.log(">>> Submitting Payload:", payload);
    onSave(payload);
  };

  if (!show) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <form onSubmit={handleSubmit}>
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">
                {formData.id ? "Edit Approval Step" : "Add New Approval Step"}
              </h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              <div className="row g-3">
                {/* Workflow Group Selection */}
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Approval Workflow Group</label>
                  <select 
                    className="form-select form-select-sm" 
                    value={formData.configGroup}
                    onChange={(e) => setFormData({...formData, configGroup: e.target.value})}
                  >
                    <option value="Office">Office Staff</option>
                    <option value="Tradesman">Tradesman (AU)</option>
                  </select>
                </div>

                {/* Step Sequence Order */}
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Step Order</label>
                  <input 
                    type="number" className="form-control form-control-sm"
                    value={formData.stepOrder}
                    onChange={(e) => setFormData({...formData, stepOrder: e.target.value})}
                  />
                </div>

                {/* Specific Approver Selection */}
                <div className="col-12">
                  <label className="form-label small fw-bold">Assign Specific Approver</label>
                  <select 
                    className="form-select form-select-sm"
                    value={formData.approverId}
                    onChange={(e) => setFormData({...formData, approverId: e.target.value})}
                  >
                    <option value="">-- No Specific User Assigned (Role Based) --</option>
                    {users && users.length > 0 ? (
                      users.map((u) => (
                        <option key={u.id} value={u.id}>
                          {u.employeeName || u.userName || u.fullName} ({u.email})
                        </option>
                      ))
                    ) : (
                      <option disabled>Fetching user directory...</option>
                    )}
                  </select>
                </div>

                {/* Position/Role Requirement */}
                <div className="col-12">
                  <label className="form-label small fw-bold">Required Authority Level</label>
                  <select 
                    className="form-select form-select-sm"
                    value={formData.position}
                    onChange={(e) => setFormData({...formData, position: parseInt(e.target.value)})}
                  >
                    <option value={0}>General Staff</option>
                    <option value={1}>Department Manager</option>
                    <option value={2}>Division Manager</option>
                    <option value={3}>Board of Directors</option>
                    <option value={4}>Tradesperson (Specialist)</option>
                  </select>
                </div>

                {/* Internal Notes */}
                <div className="col-12">
                  <label className="form-label small fw-bold">Internal Note / Instruction</label>
                  <textarea 
                    className="form-control form-control-sm" rows="2"
                    value={formData.note}
                    onChange={(e) => setFormData({...formData, note: e.target.value})}
                    placeholder="Provide additional context for this approval step..."
                  />
                </div>

                {/* CC Only Toggle */}
                <div className="col-12">
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" type="checkbox" 
                      id="isCC"
                      checked={formData.isCCOnly}
                      onChange={(e) => setFormData({...formData, isCCOnly: e.target.checked})}
                    />
                    <label className="form-check-label small" htmlFor="isCC">
                      Is CC Only (Notification only, no signature required)
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer bg-light">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-primary btn-sm px-4">
                {formData.id ? "Update Configuration" : "Create Step"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OTApprovalModal;